import { REMOVE_VEHICLES, SET_TOTAL_FILTERED_VEHICLES, SET_TOTAL_VEHICLES, SET_VEHICLE_DATA, SET_VEHICLE_FILTER_DATA, SET_VEHICLE_PERCENTAGE } from "../types";

const initialState = {
  vehicles: [],
  filterVehicles: [],
  totalVehicle: 0,
  vehiclePercentage: 0,
  totalFilteredVehicles: 0,

}

const vehiclesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VEHICLE_DATA:
      return {
        ...state,
        vehicles: action.payload,
      }
    case SET_VEHICLE_PERCENTAGE:
      return {
        ...state,
        vehiclePercentage: action.payload,
      }
    case SET_VEHICLE_FILTER_DATA:
      return {
        ...state,
        filterVehicles: action.payload,
      }
    case SET_TOTAL_VEHICLES:
      return {
        ...state,
        totalVehicle: action.payload,
      }
    case SET_TOTAL_FILTERED_VEHICLES:
      return { ...state, totalFilteredVehicles: action.payload }

    case REMOVE_VEHICLES: {
      return { vehicles: [], totalVehicle: 0 }
    }
    default:
      return state;
  }
};

export default vehiclesReducer;